__turbopack_context__.v({
  "container_noAdsLayout": "LayoutWithoutAds-module__5oLaTW__container_noAdsLayout",
  "padding0": "LayoutWithoutAds-module__5oLaTW__padding0",
  "padding30": "LayoutWithoutAds-module__5oLaTW__padding30",
  "padding52": "LayoutWithoutAds-module__5oLaTW__padding52",
});
